import { useQuery } from "@tanstack/react-query";
import { useLocation } from "@tanstack/react-location";
import { getProposalsSdk } from "../graphql/client/proposals";
export const useQueryProposal = () => {
    const { current: { hash }, } = useLocation();
    return useQuery(["governance.getProposal", hash], async () => {
        try {
            const { getProposal } = await getProposalsSdk();
            return await getProposal({ hash });
        }
        catch (e) {
            console.log(e);
            return {
                proposal: null,
            };
        }
    }, {
        suspense: true,
        staleTime: Infinity,
    });
};
//# sourceMappingURL=useQueryProposal.js.map